module.exports = __webpack_public_path__ + "static/img/yushouLC.c296c669.png";